import { useState } from 'react';

import { isNotNull } from 'utils/tsHelpers';

import { useTranslation } from '../../../../hooks/useTranslation';
import { useQueryStateContext } from '../../../../contexts';
import { useVisualComponentsContext } from '../../../../contexts/visualComponents';
import { useCampaignOptions } from './useCampaignOptions';
import { ValidatedSingleStringValueInputProps } from '../types';

export const SingleCampaignSelect = ({
  onChange,
  value,
  isInvalid,
  isOpenByDefault,
  hasWarning,
  dataType,
  field,
  fieldType,
  comparator,
}: ValidatedSingleStringValueInputProps) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState('');
  const { ConditionValueSingleStringSelect: VisualComponent } = useVisualComponentsContext();
  const { isReadOnly } = useQueryStateContext();
  const {
    options,
    selectedOptions,
    didError,
    isSelectedCampaignsLoading,
    isSuggestedCampaignsLoading,
  } = useCampaignOptions({
    search,
    values: [value].filter(isNotNull),
  });

  const isLoading = isSelectedCampaignsLoading || isSuggestedCampaignsLoading;

  const isDisabled = isReadOnly || isLoading || didError;
  const hasError = didError || !!isInvalid;

  return (
    <VisualComponent
      isDisabled={isDisabled}
      isLoading={isLoading}
      options={[...selectedOptions, ...options]}
      hasError={hasError}
      hasWarning={hasWarning}
      isOpenByDefault={isOpenByDefault}
      onChange={onChange}
      value={value}
      dataType={dataType}
      field={field}
      fieldType={fieldType}
      comparator={comparator}
      placeholder={t('v2.conditionBuilder.singleCampaignPlaceholder')}
      search={search}
      setSearch={setSearch}
    />
  );
};
